/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ProductDetailsTabs } from '@/components/blocks/ProductDetails/Tabs';
import { productDetailsContainerSX } from '@/components/blocks/ProductDetails/styles/container';
import { useProductDetails } from '@/data/Content/ProductDetails';
import { ContentProvider } from '@/data/context/content';
import { useStoreLocatorState } from '@/data/state/useStoreLocatorState';
import { ID } from '@/data/types/Basic';
import { Stack } from '@mui/material';
import { FC, useEffect, useState } from 'react';

export const PdpProductDescriptionRv: FC<{
	id: ID;
}> = ({ id }) => {
	const { storeLocator } = useStoreLocatorState();
	const [physicalStoreName, setPhysicalStoreName] = useState<string>('');
	const productDetails = useProductDetails({ partNumber: id.toString(), physicalStoreName });
	const { product, selection } = productDetails;
	
	useEffect(() => {
		setPhysicalStoreName(storeLocator.selectedStore?.physicalStoreName ?? '');
	}, [storeLocator.selectedStore]);

	return(
		<>
			{ selection && product?.partNumber && 
				<ContentProvider value={productDetails}>
					<Stack sx={productDetailsContainerSX}>
						<ProductDetailsTabs />
					</Stack>
				</ContentProvider>
			}
		</>
	);
};
